// Firebase client SDK initialisation for MyShaktiverse.
// All credentials are env-driven (REACT_APP_FIREBASE_*) — see /app/frontend/.env.

import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  signInWithPopup,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signOut as fbSignOut,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(app);

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

const facebookProvider = new FacebookAuthProvider();
facebookProvider.setCustomParameters({ display: 'popup' });

export async function signInWithGoogle() {
  const result = await signInWithPopup(firebaseAuth, googleProvider);
  return result.user;
}

export async function signInWithFacebook() {
  const result = await signInWithPopup(firebaseAuth, facebookProvider);
  return result.user;
}

export async function signUpWithEmailAndSendVerification(email, password) {
  const cred = await createUserWithEmailAndPassword(firebaseAuth, email, password);
  await sendEmailVerification(cred.user);
  return cred.user;
}

export async function resendVerification() {
  if (!firebaseAuth.currentUser) return;
  await sendEmailVerification(firebaseAuth.currentUser);
}

export async function reloadAndCheckVerified() {
  const u = firebaseAuth.currentUser;
  if (!u) return false;
  await u.reload();
  return !!firebaseAuth.currentUser?.emailVerified;
}

export async function getCurrentIdToken() {
  const u = firebaseAuth.currentUser;
  if (!u) return null;
  return u.getIdToken(/* forceRefresh */ true);
}

export async function firebaseSignOut() {
  try {
    await fbSignOut(firebaseAuth);
  } catch (_) {
    /* ignore */
  }
}
